/**
 * @generated SignedSource<<c61b3b3ecd0ca5bd49875de16f171a0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserForm_query$data = {
  readonly currentUser: {
    readonly rowId: any;
  } | null;
  readonly " $fragmentType": "UserForm_query";
};
export type UserForm_query$key = {
  readonly " $data"?: UserForm_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserForm_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserForm_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rowId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "c1d83a61c363baa7f95abe60c3feff1d";

export default node;
